const methodJson = {
    "title": "方法",
    "session": {
        "title": "团队资源",
        "text": "尽量去除各专业之间的边界，有机的融合创意设计，业务咨询，技术创新，打造引擎式的协作研发模式；通过服务设计，体验设计的方法，使每一轮解决方案的研发推进和落地验证都能确保拥有最优的资源组合和实施路径。",
        "image": "./images/method/1.png"
    },
    "principle": {
        "title": "设计原则",
        "list": [{
            "id": 1,
            "title": "以人为本",
            "text": "考量受到某个服务/产品影响的所有人的体验。"
        }, {
            "id": 2,
            "title": "包容协作",
            "text": "所有背景及专业的项目关系人都将成为服务创新设计过程中的重要参与者。"
        }, {
            "id": 3,
            "title": "迭代推进",
            "text": "服务创新设计是一个探索，适应和实验的过程，迭代式的工作方式将有效推进实施部署。"
        }, {
            "id": 4,
            "title": "延续性",
            "text": "服务创新设计是一个各专业有机组织并不断将设计可视化的一个延续的过程。"
        }, {
            "id": 5,
            "title": "真实客观",
            "text": "需求需要真实客观的调研，可落地的创意，以及对于线上线下的实际价值的评估。"
        }, {
            "id": 6,
            "title": "全面整体",
            "text": "服务创新设计将关注在整个产业链/生态圈的不同用户的整体需求，并保证其可持续性的发展。"
        }]

    },
    "process": {
        "title": "创新设计流程",
        "image": "./images/method/2.png?v=1"
    }
}

export default methodJson